/** On-screen panic copy. Never imply Makhe dispatches police or campus security. */
export const PANIC_SCREEN = {
  title: 'Alert Makhe',
  body: 'This tells Makhe operators you need help. It does not call SAPS 10111, ambulance, or campus security.',
  confirm: 'Send alert to Makhe',
  notEmergency: 'If you are in immediate danger, leave and call 10111 first.',
  sent: 'Makhe has the alert. Call 10111 if you still need police or medical help.',
} as const;

const DISPATCH_CLAIM =
  /we will (call|send|dispatch)|replaces (saps|10111)|campus (will|security) is on the way/i;

export function panicCopyClaimsDispatch(text: string): boolean {
  return DISPATCH_CLAIM.test(text);
}
